import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeIsSummaryOpened,
  downloadPdf,
  initializeSections,
  saveConfiguration,
} from '../../model/configuratorSlice';
import SummarySectionsListMobile from './SummarySectionsListMobile';
import { CloseButton, CloseButtonRollover } from '../../shared/svg/components';
import SaveConfigurationService from '../../services/SaveConfigurationService';
import DownloadPdfService from '../../services/DownloadPdfService';

const SummaryPanelMobile = () => {
  const settings = useSelector(state => state.configurator.settings);
  const isSummaryOpened = useSelector(state => state.configurator.isSummaryOpened);
  const summaryShots = useSelector(state => state.configurator.summaryShots);
  const [topShot, setTopShot] = useState(null);
  const [bottomShot, setBottomShot] = useState(null);

  const saveConfigurationMutation = SaveConfigurationService();
  const downloadPdfMutation = DownloadPdfService();
  const dispatch = useDispatch();

  useEffect(() => {

  }, [summaryShots]);

  useEffect(() => {
    dispatch(initializeSections());

    if (summaryShots != null && summaryShots.length === 2) {
      setTopShot(summaryShots[0]);
      setBottomShot(summaryShots[1]);
    }
  }, [isSummaryOpened]);

  useEffect(() => {

  }, [summaryShots]);

  return (
    <div className={`summary-panel-mobile ${isSummaryOpened ? 'opened' : ''}`}>
      <div className="summary-content">


        <SummarySectionsListMobile />
        <div className="summary-buttons-container">
          {/* <button
              className="reserve-button"
              type="button"
              onClick={null}
            >Formalizar
            </button> */}
          {/* <button
            className="save-button"
            type="button"
            onClick={() => {
              saveConfigurationMutation.mutate();
              dispatch(saveConfiguration());
            }}
          >Guardar
          </button> */}
          <button
            className="download-button"
            type="button"
            onClick={() => {
              downloadPdfMutation.mutate();
              dispatch(downloadPdf());
            }}
          ><span>Descargar Resumen</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SummaryPanelMobile;
